import React, { useContext } from 'react'
import { Box, Link, Typography } from '@mui/material'
import { CookieContext } from 'src/Libs/cookies'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/**
 *  shows message and link to accept cookies
 */
const CookieNotice: React.FC = () => {
  const cookieContext = useContext(CookieContext)
  const { t } = useCustomTranslation()

  const handleOnCookieClick = (): void => {
    cookieContext?.setDisplayCookieBanner('visible')
  }

  return (
    <Box>
      <Typography variant={'subtitle1'} sx={{ marginTop: theme => theme.spacing(2) }}>
        {t('login.rememberMe.cookieNotice')}
        <Link onClick={handleOnCookieClick} sx={{ marginLeft: theme => theme.spacing(1), cursor: 'pointer' }}>
          {t('login.rememberMe.acceptCookies')}
        </Link>
      </Typography>
    </Box>
  )
}

export default CookieNotice
